import React from 'react';
import ReactDOM from "react-dom";
import ProjetTagsComponent from './components/_projetTagsComponent.jsx';

let tagsProjets = [];
function updateTagsProjets(value) {
	tagsProjets = value;
	console.log(tagsProjets);
}
window.updateTagsProjets = updateTagsProjets;

document.querySelectorAll('[data-projettags]').forEach(function(addTagLink) {
	addTagLink.addEventListener('click', function(event) {
		event.preventDefault();

		fetch(addTagLink.dataset.projettags, {
			method: 'GET',
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
		})
		.then(response => response.json())
		.then(function(data) {
			let div = document.createElement('div');
			div.classList.add('modal', 'fade');
			div.innerHTML = '<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">Gérer les tags</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><div id="frm_projet_tags"></div></div><div class="modal-footer"><button type="button" class="btn btn-light" data-bs-dismiss="modal">Annuler</button><button type="button" class="btn btn-success" data-save>Enregistrer</button></div></div></div>';
			document.body.appendChild(div);
			const modal = new bootstrap.Modal(div);
			modal.show();
			div.addEventListener('hidden.bs.modal', function (event) {
				modal.dispose();
				div.remove();
			});

			ReactDOM.render(<ProjetTagsComponent value={data.tags} />, document.getElementById("frm_projet_tags"));

			div.querySelector('button[data-save]').addEventListener('click', function(event) {
				event.preventDefault();
				let formData = new FormData();
				formData.append('action', 'projettags');
				formData.append('id', data.id);
				formData.append('tags', JSON.stringify(tagsProjets));
				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					modal.hide();
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			});

		});
	});
});










window.initContactsListTags  = function initContactsListTags(list) {
	list.querySelectorAll('[data-addtag]').forEach(function(addTagLink) {
		addTagLink.addEventListener('click', function(event) {
			event.preventDefault();

			fetch(addTagLink.dataset.addtag, {
				method: 'GET',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			})
			.then(response => response.text())
			.then(function(data) {
				let div = document.createElement('div');
				div.classList.add('modal', 'fade');
				div.innerHTML = data;
				document.body.appendChild(div);
				const modal = new bootstrap.Modal(div);
				modal.show();
				div.addEventListener('hidden.bs.modal', function (event) {
					modal.dispose();
					div.remove();
				});

				initTagEvents(div);
			});
		});
	});

	list.querySelectorAll('[data-addtag-bulk]').forEach(function(addTagLink) {
		addTagLink.addEventListener('click', function(event) {
			event.preventDefault();

			let formData = new FormData();
			list.querySelectorAll('[data-select]:checked').forEach(function(el) {
				formData.append('id[]', el.dataset.select);
			});
			fetch(addTagLink.dataset.addtagBulk, {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				body: new URLSearchParams(formData)
			})
			.then(response => response.text())
			.then(function(data) {
				let div = document.createElement('div');
				div.classList.add('modal', 'fade');
				div.innerHTML = data;
				document.body.appendChild(div);
				const modal = new bootstrap.Modal(div);
				modal.show();
				div.addEventListener('hidden.bs.modal', function (event) {
					modal.dispose();
					div.remove();
				});

				initTagEvents(div);
			});
		});
	});

	initDeleteTagEvent(list);
}

function initDeleteTagEvent(container) {
	container.querySelectorAll('[data-deletecontacttag][data-contact]').forEach(function(deleteTagLink) {
		deleteTagLink.addEventListener('click', function(event) {
			event.preventDefault();
			let msg = deleteTagLink.dataset.confirm === undefined || deleteTagLink.dataset.confirm == '' ? 'Voulez-vous retirer ce tag ?' : deleteTagLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'deletecontacttag');
				formData.append('tag', deleteTagLink.dataset.deletecontacttag);
				formData.append('contact', deleteTagLink.dataset.contact);
				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						deleteTagLink.closest('.tag').remove();
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});
}


function initTagEvents(modal) {
	//const frmTag = document.getElementById('frm_tag');
	const listAllTags = document.getElementById('list_alltags');
	//const listContactTags = document.getElementById('list_contacttags');

	

	// modify
	modal.querySelector('[data-modifytags]').addEventListener('click', function(event) {
		event.preventDefault();

		const contactId = this.dataset.modifytags;
		let formData = new FormData();
		formData.append('action', 'modifycontacttags');
		formData.append('id', contactId);
		let tags = [];
		listAllTags.querySelectorAll('li.active').forEach(function(li) {
			tags.push(li.dataset.id);
		});
		formData.append('tags', tags);

		fetch('', {
			method: 'POST',
			headers: { 'X-Requested-With': 'XMLHttpRequest' },
			body: new URLSearchParams(formData)
		})
		.then(response => response.json())
		.then(function(data) {
			if (data.success) {
				const tagsSpan = document.querySelector('.contact_tags[data-id="' + contactId + '"]');
				tagsSpan.replaceChildren();
				data.tags.forEach(function(tag) {
					let span = document.createElement('span');
					span.classList.add('badge', 'tag');
					span.style.background = tag.color;
					span.style.color = tag.textcolor;
					span.innerHTML = tag.label + '<a href="javascript:;" data-deletecontacttag="' + tag.id + '" data-contact="' + contactId + '">&times;</a>';
					tagsSpan.append(span);
				});
				initDeleteTagEvent(tagsSpan);

				let m = bootstrap.Modal.getInstance(modal);
				m.hide();
			}
			if (data.message) {
				addToast(data.message.type, data.message.text);
			}
		});
	});

	// modify bulk
	if ( modal.querySelector('[data-modifytags-bulk]') ) {
		modal.querySelector('[data-modifytags-bulk]').addEventListener('click', function(event) {
			event.preventDefault();

			let formData = new FormData();
			formData.append('action', 'modifycontacttagsbulk');
			const contactIds = this.dataset.modifytagsBulk.split(',');
			contactIds.forEach(function(el) {
				formData.append('id[]', el);
			});

			let tags = [];
			listAllTags.querySelectorAll('li.active').forEach(function(li) {
				tags.push(li.dataset.id);
			});
			formData.append('tags', tags);

			fetch('', {
				method: 'POST',
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				body: new URLSearchParams(formData)
			})
			.then(response => response.json())
			.then(function(data) {
				if (data.success) {
					contactIds.forEach(function(contactId) {
						let tagsSpan = document.querySelector('.contact_tags[data-id="' + contactId + '"]');
						tagsSpan.replaceChildren();
						data.tags.forEach(function(tag) {
							let span = document.createElement('span');
							span.classList.add('badge', 'tag');
							span.style.background = tag.color;
							span.style.color = tag.textcolor;
							span.innerHTML = tag.label + '<a href="javascript:;" data-deletecontacttag="' + tag.id + '" data-contact="' + contactId + '">&times;</a>';
							tagsSpan.append(span);
						});
						initDeleteTagEvent(tagsSpan);
					});

					let m = bootstrap.Modal.getInstance(modal);
					m.hide();
				}
				if (data.message) {
					addToast(data.message.type, data.message.text);
				}
			});
		});
	}

	initTagItemEvents(listAllTags);
}

function initTagItemEvents(list) {

	// toggle active
	list.querySelectorAll('li').forEach(function(li) {
		li.addEventListener('click', function(event) {
			li.classList.toggle('active');
		});
	});

	// delete
	list.querySelectorAll('[data-deletetag]').forEach(function(deleteLink) {
		deleteLink.addEventListener('click', function(event) {
			event.preventDefault();
			event.stopPropagation();

			let msg = deleteLink.dataset.confirm === undefined || deleteLink.dataset.confirm == '' ? 'Voulez-vous supprimer cet élément ?' : deleteLink.dataset.confirm;
			if (window.confirm(msg)) {
				let formData = new FormData();
				formData.append('action', 'deletetag');
				formData.append('id', deleteLink.dataset.deletetag);

				fetch('', {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest' },
					body: new URLSearchParams(formData)
				})
				.then(response => response.json())
				.then(function(data) {
					if (data.success) {
						list.querySelectorAll('.list-group-item[data-id="' + deleteLink.dataset.deletetag + '"]').forEach(function(li) {
							li.remove();
						});
					}
					if (data.message) {
						addToast(data.message.type, data.message.text);
					}
				});
			}
		});
	});
}


